module.exports = __webpack_public_path__ + "static/media/flipboard.b5a7b52e.svg";